module.exports = __webpack_public_path__ + "media/images/cheers_sent_success_2-0feba87ea2723ef383bc2ec302ed3da1.gif";